module.exports = __webpack_public_path__ + "static/media/hacker-news-square.8cbbea85.svg";